import React, { useState, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router';
import moment from 'moment';
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from 'react-promise-tracker';
import { Link as LinkTo } from 'react-router-dom';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import Link from '@material-ui/core/Link';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ScheduleIcon from '@material-ui/icons/Schedule';
import esLocale from "date-fns/locale/es";
import { ButtonGroup, ClickAwayListener, Grid, Grow, ListItemIcon, MenuItem, MenuList, Paper, Popper, TextField, Typography } from '@material-ui/core';
import { DatePicker, DateRange, LocalizationProvider, TimePicker } from '@material-ui/pickers';

import SendIcon from '@material-ui/icons/Send';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { StateByRole } from '../../interfaces/StateByRole';
import { deleteScheduleMassiveEmail, scheduleMassiveEmail, sendMassiveEmail } from '../../services/AdminServices';
import { IGeneralParameter } from '../../interfaces/IGeneralParameter';
import SimpleFilterBox from '../../components/ManagementState/SimpleFilterBox';
import MoreFiltersCompany from '../../components/ManagementState/MoreFiltersCompany';
import Validations from '../../helpers/Validations';
import ShowFilters from '../../components/ManagementState/ShowFilters';
import { ChipData } from '../../interfaces/ChipData';
import { isLogin } from '../../services/AuthService';
import { containsAny, convertToBase64, removeFromStringHTML, sortByKey } from '../../helpers/sharedFunctions';
import LoadingLockPage from '../../components/ShareComponents/LoadingLockPage';
import { getEmailFrom } from '../../services/ConfigurationService';
import SuccessModal from '../ShareComponents/SuccessModal';
import ErrorModal from '../ShareComponents/ErrorModal';
import { ICompanyFilterForm } from '../../interfaces/ICompanyFilterForm';
import { ICompanyFilterObj, ICompanyScheduleMsg } from '../../interfaces/ICompanyFilterObj';
import EmailIcon from '@material-ui/icons/Email';
import { getCITY, getCOMPANY_TYPE, getCOUNTRIES_CITIES, getDEPARTAMENT, getLABORAL_SECTOR } from '../../services/ParameterService';
import { permissionAdminSendMassMsgCompanies, permissionCompanyActiveRejectedState, permissionCompanyInactiveState } from '../../utils/PermissionsVariables';
import UserContext from '../../utils/UserContext';

import './MassMessage.scss';
import { IListParametersInfo } from '../../interfaces/IListParametersInfo';
import { AttachingFile } from '../../interfaces/IGraduateFilterObjMsg';
import { IGraduateAttach } from '../../interfaces/IGraduateAttach';
import ModalOffersAction from '../LaboralOffers/ModalOffersAction';
import DateFnsUtils from '@date-io/date-fns';
import Signature from './Signature';
import { IScheduleMessage, IScheduleMessageState } from '../../interfaces/IScheduleMessage';
import LastTemplate from './LastTemplate';
import { LastTemplateModel, LastTemplateType, uploadLastMailTemplate } from '../../services/LastMailTemplateService';


const stateOptionsCompany: Array<StateByRole> = [
    { id: 1, label: 'Inscrito', value: 'Inscrito', description: 'Cambiar estado a Inscrito', permission: [] },
    { id: 2, label: 'Activo', value: 'Activo', description: 'Cambiar estado a Activo', permission: permissionCompanyActiveRejectedState },
    { id: 3, label: 'Rechazado', value: 'Rechazado', description: 'Cambiar estado a Rechazado', permission: permissionCompanyActiveRejectedState },
    { id: 4, label: 'Inactivo', value: 'Inactivo', description: 'Cambiar estado a Inactivo', permission: permissionCompanyInactiveState }
];

const filterCompanyValidation = {
    name: {
        error: "",
        validate: "textNumber",
        maxLength: 40,
        required: false
    },
    nit: {
        error: "",
        validate: "number",
        minLength: 7,
        maxLength: 15,
        required: false
    },
    laboralSector: {
        validate: "select",
        required: false
    },
    typeOfCompany: {
        validate: "select",
        required: false
    },
    country: {
        validate: "select",
        required: false
    },
    department: {
        validate: "select",
        required: false
    },
    city: {
        validate: "select",
        required: false
    },
    state: {
        validate: "select",
        required: false,
    },
    extraEmail: {
        error: "",
        validate: "emailList",
        required: true
    },
    subject: {
        error: "",
        validate: "textNumber",
        maxLength: 500,
        required: true
    },
    html: {
        error: "",
        validate: "textNumber",
        maxLength: 400,
        required: true
    },
    dateScheduled: {
        validate: "normalDate",
        minTime: new Date(),
        required: false
    },
    timeScheduled: {
        validate: "normalTime",
        minTime: new Date(),
        required: false
    }
}

const initialCompanyFilterErrors = {
    name: "",
    nit: "",
    laboralSector: "",
    typeOfCompany: "",
    country: "",
    department: "",
    city: "",
    state: "",
    createdAtStart: "",
    createdAtEnd: "",
    subject: "",
    html: "",
    extraEmail: "",
    dateScheduled: "",
    timeScheduled: ""
}

function formatTables(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach(table => {
        table.setAttribute('style', 'border-collapse: collapse; border: 1px solid #000000;');
    });

    doc.querySelectorAll('th, td').forEach(cell => {
        const existingStyle = cell.getAttribute('style') || '';
        cell.setAttribute(
            'style',
            `${existingStyle} border: 1px solid #000000; padding: 4px;`
        );
    });

    return doc.body.innerHTML;
}

const MassMessageCompany: React.FC = () => {

    const urlCompany = "/admin/dashboard/empresas";
    const location = useLocation();
    const state = location.state as IScheduleMessageState | undefined;
    const scheduledMessage = state?.scheduledMessage;
    const { promiseInProgress } = usePromiseTracker();
    const userContext = React.useContext(UserContext);
    const [filterValues, setFilterValues] = useState<ICompanyFilterForm>(new ICompanyFilterForm());
    const [filterValuesAttach, setFilterValuesAttach] = useState<IGraduateAttach>(new IGraduateAttach())
    const [formErrors, setFormErrors] = useState(initialCompanyFilterErrors);
    const anchorRef = React.useRef<HTMLButtonElement | null>(null);
    const [scheduleTime, setScheduleTime] = useState<string | undefined>();
    const [allLaboralSector, setAllLaboralSector] = useState<Array<IGeneralParameter>>([]);
    const [allCompanyType, setAllCompanyType] = useState<Array<IGeneralParameter>>([]);
    const [countryCitiesArray, setCountryCitiesArray] = useState<Array<IListParametersInfo>>([]);
    const [departmentArray, setDepartmentArray] = useState<Array<IGeneralParameter>>([]);
    const [cityArray, setCityArray] = useState<Array<IGeneralParameter>>([]);
    const [cities, setCities] = useState<Array<IGeneralParameter>>([]);
    const [chipData, setChipData] = React.useState<ChipData[]>([]);
    const [chipDataEmails, setChipDataEmails] = useState<ChipData[]>([]);
    const [recordsfound, setRecordsFound] = useState<number>(0);
    const [senderMail, setSenderMail] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [edit, setEdit] = useState(false);
    const [openModalSuccess, setOpenModalSuccess] = useState(false);
    const [openModalError, setOpenModalError] = useState(false);
    const [opeModalConfirm, setOpenModalConfirm] = useState<boolean>(false);
    const [errorDocument, setErrorDocument] = useState<string>('');
    const [open, setOpen] = React.useState(false);
    const [schedule, setSchedule] = React.useState(false);
    const [signatureAttach, setSignatureAttach] = useState<IGraduateAttach>(new IGraduateAttach())
    const [stateCheck, setStateCheck] = useState<any>({
        Inscrito: false,
        Activo: false,
        Rechazado: false,
        Inactivo: false
    });

    const isValidAddEmail =
        filterValues.extraEmail.length > 0 &&
        !formErrors.extraEmail

    const isValidSend =
        filterValues.subject.length > 0 &&
        !formErrors.subject &&
        filterValues.html.length > 0 &&
        signatureAttach.attachingFiles.length > 0 &&
        filterValues.html.length > 0 &&
        !formErrors.html &&
        (
            recordsfound > 0 ||
            filterValues.aditionalEmails.length > 0
        )

    const isValid =
        !formErrors.name &&
        !formErrors.nit &&
        !formErrors.createdAtStart &&
        !formErrors.createdAtEnd

    const isValidSchedule =
        !formErrors.timeScheduled &&
        !formErrors.dateScheduled &&
        filterValues.dateScheduled != null &&
        filterValues.timeScheduled != null;

    useEffect(() => {
        window.scrollTo(0, 0);
        const getInitialData = async () => {
            setStateCheck({ ...stateCheck, "Activo": true });
            const responseSender: any = await getEmailFrom();
            if (responseSender) {
                const emailReceived = await responseSender.message.value;
                setSenderMail(emailReceived)
            }
            //  company type
            let responseCompanyType: any = await getCOMPANY_TYPE();
            responseCompanyType = sortByKey(responseCompanyType, 'name');
            setAllCompanyType(responseCompanyType)
            //  laboral sector
            let responseLaboralSector: any = await getLABORAL_SECTOR();
            responseLaboralSector = sortByKey(responseLaboralSector, 'name');
            setAllLaboralSector(responseLaboralSector)
            // data countries-cities
            let dataCountryCitiesRes: any = await getCOUNTRIES_CITIES();
            let dataCountryCities = dataCountryCitiesRes.list;
            dataCountryCities = sortByKey(dataCountryCities, 'grandParentName');
            setCountryCitiesArray(dataCountryCities);
            //data for departments field
            const dataDepartment: any = await getDEPARTAMENT();
            setDepartmentArray(dataDepartment ? dataDepartment : []);
            //data for cities
            const dataCity: any = await getCITY();
            setCityArray(dataCity ? dataCity : []);
        }
        getInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (filterValues.country === 0) {
            setFilterValues(prev => ({
                ...prev,
                department: 0,
                city: 0
            }));
            setCities([]);
        } else {
            if (filterValues.country === 170) {
                setCities([]);
            } else {
                setFilterValues(prev => ({
                    ...prev,
                    department: 0,
                    city: 0
                }));
                const countryObjSelected = countryCitiesArray.find(country => country.id === filterValues.country);
                if (countryObjSelected) {
                    setCities(countryObjSelected.childs);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues.country])


    useEffect(() => {
        if (!edit) {
            setFilterValues(prev => ({
                ...prev,
                city: 0
            }))

        }
        setEdit(false);
        if (filterValues.department > 0) {
            let citiesDep: Array<IGeneralParameter> = cityArray.filter(city => city.parentId === filterValues.department);
            citiesDep = sortByKey(citiesDep, 'name');
            if (citiesDep.length > 0) {
                setCities(citiesDep);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues.department])


    const setChips = () => {
        let tempArray: Array<ChipData> = []
        let index = 0;
        const fieldNames = [
            { key: 'name', description: 'Razón social' },
            { key: 'nit', description: 'Nit de la empresa' },
            { key: 'laboralSector', description: 'Sector laboral' },
            { key: 'typeOfCompany', description: 'Tipo de empresa' },
            { key: 'country', description: 'País' },
            { key: 'department', description: 'Departamento' },
            { key: 'city', description: 'Municipio' },
            { key: 'rangeRegister', description: 'Fecha de inscripción' }
        ]
        for (const [key, value] of Object.entries(filterValues)) {
            if (value !== 0 && value !== '' && value !== null && value !== undefined && value.length !== 0 && fieldNames.find(field => field.key === key)) {
                if (value[0] !== null && value[1] !== null) {
                    let obj;
                    const fieldObj = fieldNames.find(field => field.key === key);
                    if (key === 'laboralSector') {
                        obj = allLaboralSector.find(sector => sector.parameter_code === value);
                    } else if (key === 'typeOfCompany') {
                        obj = allCompanyType.find(Tcompany => Tcompany.parameter_code === value);
                    } else if (key === 'country' && value === 170) {
                        obj = { name: 'Colombia' }
                    } else if (key === 'department') {
                        obj = departmentArray.find(dep => dep.parameter_code === value);
                    } else if (key === 'city') {
                        obj = cities.find(city => city.parameter_code === value);
                    } else if (key === 'rangeRegister') {
                        const startDate: string = moment(value[0]).format('DD/MM/YYYY');
                        const endDate: string = moment(value[1]).format('DD/MM/YYYY');
                        obj = { name: `${startDate} hasta ${endDate}` }
                    }
                    if (obj) {
                        tempArray.push({ key: index, name: key, label: fieldObj?.description + ': ' + obj.name })
                    } else {
                        tempArray.push({ key: index, name: key, label: fieldObj?.description + ': ' + value })
                    }
                    index++;
                }
            }
        }
        setChipData(tempArray)
    };

    const handleDeleteChip = (chipToDelete: ChipData) => () => {
        const name = chipToDelete.name;
        setChipData((chips) => chips.filter((chip) => chip.name !== chipToDelete.name));
        if (name === 'laboralSector' || name === 'typeOfCompany' || name === 'country' || name === 'department' || name === 'city') {
            setFilterValues(prev => ({
                ...prev,
                [chipToDelete.name]: 0
            }));
        } else if (name === 'rangeRegister') {
            setFilterValues(prev => ({
                ...prev,
                [name]: [null, null]
            }));
        } else {
            setFilterValues(prev => ({
                ...prev,
                [chipToDelete.name]: ''
            }));
        }
    };

    useEffect(() => {
        if (isValid) {
            setChips();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues, isValid])

    const transformDataCompany = (values: ICompanyFilterForm, preview: boolean, scheduleTime?: string) => {
        const temporaryObject: ICompanyFilterObj = new ICompanyFilterObj();
        temporaryObject.type = "company";
        temporaryObject.preview = preview;
        if (values.name !== "") {
            temporaryObject.filters.name = values.name;
        } else { delete temporaryObject.filters.name }
        if (values.nit === null || values.nit === "") {
            delete temporaryObject.filters.nit
        } else { temporaryObject.filters.nit = parseInt(values.nit); }
        if (values.laboralSector > 0) {
            temporaryObject.filters.laboralSector = values.laboralSector;
        } else { delete temporaryObject.filters.laboralSector }
        if (values.typeOfCompany > 0) {
            temporaryObject.filters.typeOfCompany = values.typeOfCompany;
        } else { delete temporaryObject.filters.typeOfCompany }
        if (values.country > 0) {
            temporaryObject.filters.country = values.country;
        } else { delete temporaryObject.filters.country }
        if (values.department > 0) {
            temporaryObject.filters.department = values.department;
        } else { delete temporaryObject.filters.department }
        if (values.city > 0) {
            temporaryObject.filters.city = values.city;
        } else { delete temporaryObject.filters.city }
        if (values.rangeRegister[0] !== null && values.rangeRegister[1] !== null) {
            if (temporaryObject.filters.rangeRegister) {
                temporaryObject.filters.rangeRegister.sinceDate = moment(values.rangeRegister[0]).format("YYYY-MM-DD");
                temporaryObject.filters.rangeRegister.untilDate = moment(values.rangeRegister[1]).format("YYYY-MM-DD");
            }
        } else { delete temporaryObject.filters.rangeRegister }
        const foundSelected = Object.keys(stateCheck).filter(item => stateCheck[item] === true);
        if (foundSelected.length > 0) {
            temporaryObject.filters.state = foundSelected
        } else { delete temporaryObject.filters.state }
        if (filterValues.subject !== "") {
            temporaryObject.subject = filterValues.subject;
        }
        if (filterValues.html === "" || filterValues.html === "<p><br></p>") {
            temporaryObject.html = "";
        } else {
            temporaryObject.html = filterValues.html;
            temporaryObject.html += "<br><br> Atentamente: <br/><br/><img src=\"" + signatureAttach.attachingFiles[0].previewUrl.split('?')[0] + "\" alt=\"" + signatureAttach.attachingFiles[0].filename + "\"/>"
        }
        if (filterValues.aditionalEmails.length > 0) {
            temporaryObject.aditionalEmails = filterValues.aditionalEmails;
        }
        if (filterValues.attachingFiles.length > 0) {
            filterValues.attachingFiles.map(item => delete item.previewUrl);
            temporaryObject.attachingFiles = filterValues.attachingFiles;
        }

        if (schedule) {
            const scheduleObject: ICompanyScheduleMsg = new ICompanyScheduleMsg();
            scheduleObject.emailData = temporaryObject;
            //reschedule message
            if (scheduleObject.emailData && scheduleObject.emailData.html) {
                scheduleObject.emailData.html = removeFromStringHTML(scheduleObject.emailData.html, "signature")
            }
            if (scheduledMessage) {
                scheduleObject.ruleName = scheduledMessage.ruleName;
                scheduleObject.newScheduleTime = scheduleTime;
            } else {
                scheduleObject.scheduleTime = scheduleTime;
            }
            return scheduleObject;
        }

        return temporaryObject;
    }

    useEffect(() => {
        const transformDataToSchedule = (scheduledMessage: IScheduleMessage) => {

            const selectedStates = scheduledMessage.emailData?.filters?.state || [];

            const updatedStateCheck = Object.keys(stateCheck).reduce((acc, key) => {
                acc[key] = selectedStates.includes(key);
                return acc;
            }, {} as typeof stateCheck);


            setStateCheck(updatedStateCheck);
            setFilterValues(prev => ({
                ...new ICompanyFilterForm(),
                subject: scheduledMessage.emailData!.subject,
                name: scheduledMessage.emailData!.filters!.name,
                nit: scheduledMessage.emailData!.filters!.nit,
                state: stateOptionsCompany.filter(option => scheduledMessage.emailData?.filters?.state?.includes(option.value)),
                laboralSector: scheduledMessage.emailData?.filters?.laboralSector ?? 0,
                typeOfCompany: scheduledMessage.emailData?.filters?.typeOfCompany ?? 0,
                country: scheduledMessage.emailData?.filters?.country ?? 0,
                department: scheduledMessage.emailData?.filters?.department ?? 0,
                city: scheduledMessage.emailData?.filters?.city ?? 0,
                rangeRegister: [scheduledMessage.emailData?.filters?.rangeRegister?.sinceDate || null, scheduledMessage.emailData?.filters?.rangeRegister?.untilDate || null],
                html: scheduledMessage!.emailData!.html,
                dateScheduled: moment(scheduledMessage.eventDate).toDate(),
                timeScheduled: moment(scheduledMessage.eventDate).toDate(),
            }));


            const scheduleTime = moment(scheduledMessage.eventDate).toDate();
            setScheduleTime(scheduleTime.toISOString());

            prepareEmail((scheduledMessage.emailData!.aditionalEmails || []).join(","));


            if (scheduledMessage.emailData?.attachingFiles && scheduledMessage.emailData?.attachingFiles.length > 0) {

                const newFiles = scheduledMessage.emailData?.attachingFiles;

                if (newFiles && newFiles.length > 0) {
                    setFilterValuesAttach(prev => ({
                        ...prev,
                        attachingFiles: [...prev.attachingFiles, ...newFiles]
                    }));
                }
            }

        }

        if (scheduledMessage && cityArray.length > 0 && departmentArray.length > 0) {
            transformDataToSchedule(scheduledMessage);
            setEdit(true);
        }

    }, [scheduledMessage, departmentArray, cityArray]);


    const clickApplyFilters = async (value: any, action: string) => {
        if (action === 'apply') {
            const objectToSend = transformDataCompany(filterValues, true);
            const additionalEmailsText = filterValues.aditionalEmails.length > 0 
            ? `|correos adicionales: ${filterValues.aditionalEmails.join(',')}` 
            : '';
            const chipLabels = chipData.map(chip => chip.label).join('|');
            const finalTextFilters = `${chipLabels}${additionalEmailsText}`;
            const responseMassiveMsg: any = await trackPromise(sendMassiveEmail(
                objectToSend,   
                finalTextFilters
            ))
            if (responseMassiveMsg.status === 200) {
                const result = await responseMassiveMsg.json();
                setRecordsFound(result.total);
                setChips();
            } else {
                setOpenModalError(true);
                setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general")
            }
        } else if (action === 'clear') {
            setChipData([]);
            setFilterValues(new ICompanyFilterForm());
            setFormErrors(initialCompanyFilterErrors);
            setRecordsFound(0);
        }
    }

    const handleChangeState = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStateCheck({ ...stateCheck, [event.target.name]: event.target.checked });
    };


    const changeFilterForm = (e: any) => {
        const { name, value } = e.target;
        setFilterValues(prev => ({
            ...prev,
            [name]: value
        }));
        const error: string = Validations(name, value, filterCompanyValidation) || "";
        setFormErrors(prev => ({
            ...prev,
            [name]: error
        }));
    }

    const changeFilterDates = (name: string, dateValue: DateRange<Date>) => {
        setFilterValues(prev => ({
            ...prev,
            [name]: dateValue
        }));
        const startDate: string = moment(dateValue[0]).format('YYYY/MM/DD');
        const endDate: string = moment(dateValue[1]).format('YYYY/MM/DD');
        let labelStart: string = "";
        let labelEnd: string = "";
        const valueStart = startDate === "Fecha inválida" ? "Fecha inválida" : "";
        const valueEnd = endDate === "Fecha inválida" ? "Fecha inválida" : "";
        if (name === "rangeRegister") {
            labelStart = "createdAtStart";
            labelEnd = "createdAtEnd";
        }
        errorDates(labelStart, valueStart);
        errorDates(labelEnd, valueEnd);
    }

    const errorDates = (label: string, value: string) => {
        setFormErrors(prev => ({
            ...prev,
            [label]: value
        }));
    }

    const handleChangeEditor = (value: any) => {
        const cleanedValue = value.length > 0 && value !== "<p><br></p>" ? formatTables(value) : "";

        setFilterValues((prev: any) => ({
            ...prev,
            html: cleanedValue,
        }));
    };

    const handleClickLastTemplate = (lastTemplate: LastTemplateModel) =>{
        handleChangeEditor(lastTemplate.body);
        setFilterValues((prev: any) => ({
            ...prev,
            subject: lastTemplate.subject,
        }));
        setFilterValuesAttach((prev: any) => ({
            ...prev,
            attachingFiles: lastTemplate.attachments,
        }));
    }

    const buttonList = [
        ['undo', 'redo'],
        ['formatBlock', 'font', 'fontSize'],
        ['fontColor', 'hiliteColor'],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        ['list', 'align', 'outdent', 'indent'],
        ['link', 'image'],
        ['table'],
        ['removeFormat'],
    ]

    const font = [
        'Arial',
        'Comic Sans MS',
        'Courier New',
        'Impact',
        'Georgia',
        'Tahoma',
        'Trebuchet MS',
        'Verdana',
    ]

    const prepareEmail = (emails: string) => {

        const foundEmails = emails.split(",").map(email => email.trim());

        const tempArrayEmails: ChipData[] = [
            ...filterValues.aditionalEmails.map((email, i) => ({ key: i, name: email, label: email })),
            ...foundEmails.map((email, i) => ({ key: filterValues.aditionalEmails.length + i, name: email, label: email }))
        ];

        setFilterValues(prev => ({
            ...prev,
            aditionalEmails: [...prev.aditionalEmails, ...foundEmails],
            extraEmail: ''
        }));

        setChipDataEmails(tempArrayEmails);

    }

    const addEmail = () => {
        prepareEmail(filterValues.extraEmail);
    }

    const handleDeleteEmail = (chipToDelete: ChipData) => () => {
        const name = chipToDelete.name;
        setChipDataEmails((chips) => chips.filter((chip) => chip.name !== chipToDelete.name));
        const newArrayEmails = filterValues.aditionalEmails.filter(chip => name !== chip);
        setFilterValues(prev => ({
            ...prev,
            aditionalEmails: newArrayEmails
        }))
    }

    const confirmSend = async () => {
        setSchedule(false);
        setOpenModalConfirm(true);
    }
    const closeModalConfirm = () => {
        setOpenModalConfirm(false);
    }


    const deleteSchedule = async (): Promise<boolean> => {
        const objectToSend = {
            "ruleName": scheduledMessage?.ruleName,
        }

        const response: any = await trackPromise(deleteScheduleMassiveEmail(objectToSend));

        if (response.status != 200) {
            setOpenModalError(true);
            setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general");
            return false;
        }
        return true;
    }

    const sendEmail = async () => {
        setOpenModalConfirm(false);
        filterValues.attachingFiles = filterValuesAttach.attachingFiles
        const additionalEmailsText = filterValues.aditionalEmails.length > 0 
            ? `|correos adicionales: ${filterValues.aditionalEmails.join(',')}` 
            : '';
        const chipLabels = chipData.map(chip => chip.label).join('|');
        const finalTextFilters = `${chipLabels}${additionalEmailsText}`;
        let responseMassiveMsg: any;
        if (schedule) {
            const objectToSend = transformDataCompany(filterValues, false, scheduleTime);
            responseMassiveMsg = await trackPromise(scheduleMassiveEmail(
                objectToSend,
                finalTextFilters,
                scheduledMessage ? 'PUT' : 'POST'
            ))
        } else {
            if (scheduledMessage) {
                const result = await deleteSchedule();
                if (result === false) {
                    return;
                }
            }
            await uploadLastMailTemplate({
                body:filterValues.html,
                subject: filterValues.subject,
                attachments: filterValuesAttach.attachingFiles,
                type: LastTemplateType.COMPANY
            });
            const objectToSend = transformDataCompany(filterValues, false);
            responseMassiveMsg = await trackPromise(sendMassiveEmail(
                objectToSend,
                finalTextFilters
            ));
        }


        if (responseMassiveMsg.status === 200) {
            setOpenModalSuccess(true);
            setSuccessMessage(schedule ? "Mensaje programado" : "Mensaje enviado");
            setChips();
        } else {
            setOpenModalError(true);
            setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general")
        }
        setSchedule(false);
    }

    const handleCloseModalSuccess = () => {
        setOpenModalSuccess(false);
        window.location.reload();
    };

    const handleCloseModalError = () => {
        setOpenModalError(false);
        window.location.reload();
    };

    const handleUploadDocuments = async (e: any) => {
        setErrorDocument('');
        const { name } = e.target;
        if (name === "otherFiles" && e.target.files.length > 0) {
            const file = e.target.files[0];
            const allowedTypes = [
                "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.spreadsheet",
                "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.oasis.opendocument.presentation", "image/jpeg", "image/png", "image/gif",
                "image/svg+xml", "image/bmp", "image/tiff", "text/csv", "text/plain", "application/json",
                "application/xml", "application/zip", "application/x-rar-compressed", "application/x-7z-compressed",
                "video/mp4", "video/x-msvideo", "video/quicktime"
            ];

            if (allowedTypes.includes(file.type)) {
                const base64File: any = await convertToBase64(file);
                if (base64File.length > 0) {
                    const newFileBase64: AttachingFile = {
                        base64: base64File,
                        type: file.type,
                        filename: file.name,
                        previewUrl: URL.createObjectURL(file)
                    };

                    setFilterValuesAttach(prev => ({
                        ...prev,
                        attachingFiles: [...prev.attachingFiles, newFileBase64]
                    }));
                }
            } else {
                setErrorDocument('Solo puede subir archivos en formatos permitidos.');
            }
        }
    }

    const handleDeleteFile = async (fileToDelete: AttachingFile) => {
        const newFiles = filterValuesAttach.attachingFiles && filterValuesAttach.attachingFiles.filter((obj: AttachingFile) => obj.filename !== fileToDelete.filename);
        setFilterValuesAttach(prev => ({
            ...prev,
            attachingFiles: newFiles
        }))
    }

    const options = [{ id: 0, text: 'Enviar' }, { id: 1, text: 'Programar' }];

    const scheduleMessage = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        id: number,
    ) => {
        setOpen(false);
        setSchedule(true);
        setOpenModalConfirm(true);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const cancel = () => {
        window.location.reload();
    }
    
    const handleChangeDate = (dateValue: Date | null, nameField: string) => {
        const value = dateValue ? dateValue?.toString() : '';
        if (nameField === 'dateScheduled') {
            const timeScheduled = moment(filterValues.timeScheduled);
            const valueSet = dateValue ? dateValue.setHours(timeScheduled.hour(), timeScheduled.minute(), timeScheduled.second(), 0) : '';
            setFilterValues((prev: any) => ({
                ...prev,
                [nameField]: new Date(valueSet)
            }));
            const error: string = Validations(nameField, value, filterCompanyValidation) || "";
            setFormErrors((prev: any) => ({
                ...prev,
                [nameField]: error
            }));

            setScheduleTime(new Date(valueSet).toISOString());
        } else {
            setFilterValues((prev: any) => ({
                ...prev,
            }));
            if (filterValues.dateScheduled !== null) {
                const dateStartValue = moment(new Date(filterValues.dateScheduled)).locale('es').utcOffset(-5, true).format('YYYY-MM-DD');
                const currentDateValue = moment(new Date()).locale('es').utcOffset(-5, true).format('YYYY-MM-DD');
                if (moment(value).isValid()) {
                    const timeStartValue = moment(new Date(value)).format('HH:mm:ss');
                    const dateTimeStart = new Date(dateStartValue + " " + timeStartValue);
                    setFilterValues((prev: any) => ({
                        ...prev,
                        [nameField]: dateTimeStart
                    }));
                    if (dateStartValue > currentDateValue) {
                        filterCompanyValidation.timeScheduled.minTime = moment(dateStartValue + " 00:00:00").toDate();
                    } else {
                        const currentTime = moment(new Date()).format('HH:mm:ss');
                        filterCompanyValidation.timeScheduled.minTime = moment(dateStartValue + " " + currentTime).toDate();
                    }
                    const error: string = Validations(nameField, dateTimeStart.toISOString(), filterCompanyValidation) || "";
                    setScheduleTime(dateTimeStart.toISOString());
                    setFormErrors((prev: any) => ({
                        ...prev,
                        [nameField]: error
                    }));
                } else {
                    setFormErrors((prev: any) => ({
                        ...prev,
                        [nameField]: "Hora invalida"
                    }));
                }
            }
        }
    };

    return (
        <>
            {isLogin() ?
                <>
                    <Grid container className="main-container">
                        <Grid container item xs={12}>
                            <Grid item xs={12} md={4}>
                                <div className="title-section-line">
                                    <EmailIcon className="group-icon" />
                                    <Typography variant="h2" className="message-title" >
                                        Mensajería masiva empresas
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8} className="line" />
                            <Grid item xs={10} md={4} lg={10}>
                                <div className="title-section-line">
                                    <Typography variant="h3" className="message-title" >
                                        <b className="red-title">Importante:</b> Si necesita enviar un correo a todas las empresas activas en el SIE, se recomienda sobre la subsección de Estado de la empresa aplicar el estado “Activo” o los filtros que se requieren.
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <SimpleFilterBox title="Estado de la empresa" subtitle="Filtrar por estados:" stateCheck={stateCheck} onChangeState={handleChangeState} stateOptions={stateOptionsCompany} />
                        </Grid>
                        <Grid container item xs={12}>
                            <MoreFiltersCompany titleSection="Agregar otros filtros de búsqueda" formValues={filterValues} formErrors={formErrors} onChangeForm={changeFilterForm} changeFilterDates={changeFilterDates} allLaboralSector={allLaboralSector} allCompanyType={allCompanyType} countryCitiesArray={countryCitiesArray} departmentArray={departmentArray} cities={cities} reportForm={false} stateOptions={stateOptionsCompany} msgForm={true} />
                        </Grid>
                        <Grid container item xs={12}>
                            <ShowFilters titleSection="Filtros seleccionados" filtersData={chipData} stateCheck={stateCheck} showButtons={true} showDelete={true} deleteFilter={handleDeleteChip} isValid={isValid} onApplyFilters={clickApplyFilters} />
                        </Grid>

                        <Grid container item xs={12} className="mass-message-container">
                            <Grid container item xs={12} className="message-container">
                                <Grid container item xs={12} className="title-container-message">
                                    <Typography variant="h2" className="title">
                                        Destinatarios
                                    </Typography>
                                </Grid>
                                <Grid container item xs={12} direction="row" className="message-content">
                                    {recordsfound > 0 &&
                                        <Grid item xs={12} className="field-box-margin">
                                            <Typography variant="h4" className="field-box-title-company">
                                                Total de empresas encontradas: {recordsfound}
                                            </Typography>
                                        </Grid>
                                    }
                                    <Grid container item xs={12} className="line" />
                                    <Grid item xs={12} md={12} className="field-box-margin">
                                        <Typography variant="h4" className="field-box-title-company">
                                            Añadir correos manualmente
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            name="extraEmail"
                                            placeholder="Correo adicional"
                                            variant="outlined"
                                            multiline
                                            value={filterValues.extraEmail || ""}
                                            onChange={changeFilterForm}
                                            error={!!formErrors.extraEmail}
                                            helperText={formErrors.extraEmail}
                                            margin="none"
                                        />
                                    </Grid>
                                    <Grid container item xs={12} md={12} className="field-box-margin" justify="flex-end" alignItems="flex-end">
                                        <div>
                                            <Button disabled={!isValidAddEmail} variant="contained" className="add-email-button" onClick={addEmail}>
                                                <Typography variant="h5" className="regular-serif">
                                                    Adicionar correo
                                                </Typography>
                                            </Button>
                                        </div>
                                    </Grid>
                                    <Grid container item xs={12} className="line" />
                                    {chipDataEmails.length > 0 &&
                                        <Grid container item xs={12}>
                                            <ShowFilters titleSection="Correos agregados" filtersData={chipDataEmails} stateCheck={stateCheck} showButtons={false} showDelete={true} deleteFilter={handleDeleteEmail} />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} className="message-container">
                                <Grid container item xs={12} className="title-container-message">
                                    <Typography variant="h2" className="title">
                                        Contenido
                                    </Typography>
                                </Grid>
                                <Grid container item xs={12} direction="row" className="message-content">
                                    <Grid item xs={12} sm={6} className="field-box-margin">
                                        <Typography variant="h4" className="field-box-title-company link-responsive">
                                            Remitente: {senderMail}
                                        </Typography>
                                    </Grid>
                                    <Grid container item xs={12} className="line" />
                                    <Grid item xs={12} className="field-box-margin">
                                        <Typography variant="h4" className="field-box-title-company">
                                            Asunto*
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            name="subject"
                                            placeholder="Asunto"
                                            variant="outlined"
                                            value={filterValues.subject || ""}
                                            onChange={changeFilterForm}
                                            error={!!formErrors.subject}
                                            helperText={formErrors.subject}
                                            margin="none"
                                        />
                                    </Grid>
                                    <Grid item xs={12} className="field-box-margin">
                                        <Typography variant="h4" className="field-box-title-company">
                                            Cuerpo del correo*
                                        </Typography>
                                        <LastTemplate updateMailBodyParent={handleClickLastTemplate} type={LastTemplateType.COMPANY} />
                                        <Grid item xs={12}>
                                            <SunEditor
                                                placeholder="Crea un descripción detallada en este espacio"
                                                setOptions={{
                                                    height: 'auto',
                                                    minHeight: '100px',
                                                    resizingBar: false,
                                                    buttonList: buttonList,
                                                    font: font,
                                                    formats: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote']
                                                }}
                                                onChange={handleChangeEditor}
                                                setContents={filterValues.html}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className="line" />
                                    <Grid item xs={12} className="documents-mass-message">
                                        <Typography variant="h5" className="description-documents-text regular-serif">En esta sección puede adjuntar documentos que desea enviar como adjuntos en el correo. Para adjuntar el documento de clic en el botón "Adjuntar archivo" y seleccione el documento que desea adjuntar. El documento debe estar en formato pdf.</Typography>
                                        {
                                            filterValuesAttach.attachingFiles.length > 0 &&
                                            <Grid container item xs={12} justify="flex-start" direction="column">
                                                {filterValuesAttach.attachingFiles.map((file, index) => (
                                                    <div key={index} className="list-file-element">
                                                        <Link target="_blank" rel="noopener" href={file.previewUrl}>
                                                            <Typography align="center" variant="h6" className="regular-serif">
                                                                {file.filename}
                                                            </Typography>
                                                        </Link>
                                                        <IconButton className="ico-delete" onClick={() => handleDeleteFile(file)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </div>
                                                ))}
                                            </Grid>
                                        }
                                        <Typography variant="h6" className="Regular-serif primaryError">
                                            {errorDocument}
                                        </Typography>
                                        <Grid container item xs={12} justify="flex-start">
                                            <div className="upload-button-container">
                                                <Button variant="contained" component="label" className="upload-button">
                                                    <Typography variant="h5" className="regular-serif">
                                                        Adjuntar archivo
                                                    </Typography>
                                                    <div>
                                                        <input type="file" name="otherFiles" onChange={handleUploadDocuments} accept=".pdf,.doc,.docx,.odt,.xls,.xlsx,.ods,.ppt,.pptx,.odp,.jpg,.jpeg,.png,.gif,.svg,.bmp,.tiff,.zip,.rar,.7z,.csv,.txt,.json,.xml,.mp4,.avi,.mov" hidden />
                                                    </div>
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className="line" />
                                    <Signature updateSignatureParent={setSignatureAttach} />
                                    <Grid container item xs={12} className="line" />
                                    <Grid container item xs={12} className="container-buttons-message">
                                        <Button variant="contained" className="cancel-button" onClick={cancel} startIcon={<ChevronLeftIcon />} >
                                            <Typography variant="h5" className="regular-serif">
                                                Cancelar
                                            </Typography>
                                        </Button>
                                        {containsAny(permissionAdminSendMassMsgCompanies, userContext.userPermissions) &&
                                            <>
                                                <ButtonGroup variant="contained">
                                                    <Button disabled={!isValidSend}
                                                        onClick={confirmSend} className="send-button">
                                                        <Typography variant="h5" className="regular-serif">
                                                            {options[0].text}
                                                        </Typography>
                                                    </Button>
                                                    {options.length > 1 &&
                                                        <>
                                                            <Button disabled={!isValidSend}
                                                                className="other-button"
                                                                ref={anchorRef}
                                                                aria-haspopup="menu"
                                                                onClick={handleToggle}
                                                            >
                                                                <ArrowDropDownIcon />
                                                            </Button>
                                                        </>
                                                    }

                                                </ButtonGroup>

                                                <Popper
                                                    open={open}
                                                    anchorEl={anchorRef.current}
                                                    role={undefined}
                                                    transition
                                                    disablePortal

                                                >
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{
                                                                transformOrigin: 'center bottom',
                                                            }}
                                                        >
                                                            <Paper>
                                                                <ClickAwayListener onClickAway={handleClose}>
                                                                    <MenuList id="split-button-menu" autoFocusItem>
                                                                        {options.filter((option, id) => option.id != 0).map((option, id) => (
                                                                            <MenuItem
                                                                                key={option.id}
                                                                                onClick={(event) => scheduleMessage(event, id)}
                                                                            >
                                                                                <ListItemIcon>
                                                                                    <ScheduleIcon />
                                                                                    <Typography variant="h5" className="regular-serif">
                                                                                        {option.text}
                                                                                    </Typography>
                                                                                </ListItemIcon>
                                                                            </MenuItem>
                                                                        ))}
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </>
                                        }
                                        <ModalOffersAction
                                            open={opeModalConfirm}
                                            handleClose={closeModalConfirm}
                                            handleContinue={sendEmail}
                                            iconModal={!schedule ? <WarningIcon className="big-info-icon" /> : <InfoIcon className="big-info-icon" />}
                                            title={schedule ? "Programar envío" : "¿Está seguro de enviar el correo?"}
                                            headerdescription={schedule ? "Ingrese fecha y hora" : ""}
                                            description={!schedule ? "Esta intentando enviar un correo a uno o mas destinatarios" : ""}
                                            backBtnText="Regresar"
                                            colorBtnBack=""
                                            continueBtnText={schedule ? "Programar" : "Si, Continuar"}
                                            colorBtnContinue="#14A5DC"
                                            valid={schedule ? isValidSchedule : true}
                                            children={
                                                schedule ?
                                                    <>
                                                        <Grid item container spacing={1} className="field-box-margin special-box-right">
                                                            <Grid item xs={6}>
                                                                <Typography variant="h5" className="field-box-title">Fecha*</Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Typography variant="h5" className="field-box-title">Hora*</Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <LocalizationProvider dateAdapter={DateFnsUtils} locale={esLocale}>
                                                                    <DatePicker
                                                                        views={['year', 'month', 'date']}
                                                                        value={filterValues.dateScheduled || null}
                                                                        onChange={(value) => handleChangeDate(value, 'dateScheduled')}
                                                                        minDate={new Date(new Date().setDate(new Date().getDate()))}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                disabled
                                                                                {...params}
                                                                                fullWidth
                                                                                margin="none"
                                                                                name="dateScheduled"
                                                                                error={!!formErrors.dateScheduled}
                                                                                helperText={formErrors.dateScheduled}
                                                                                InputLabelProps={{ shrink: false }}
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item xs={6}>

                                                                <LocalizationProvider dateAdapter={DateFnsUtils} locale={esLocale}>
                                                                    <TimePicker
                                                                        value={filterValues.timeScheduled || null}
                                                                        ampm={true}
                                                                        onChange={(value) => handleChangeDate(value, 'timeScheduled')}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                disabled
                                                                                {...params}
                                                                                fullWidth
                                                                                name="timeScheduled"
                                                                                margin="none"
                                                                                error={!!formErrors.timeScheduled}
                                                                                helperText={formErrors.timeScheduled}
                                                                                InputLabelProps={{ shrink: false }}
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                        </Grid>
                                                    </> : null
                                            }
                                        />
                                        <SuccessModal successMsg={successMessage} handleCloseModal={handleCloseModalSuccess} openModalSuccess={openModalSuccess} />
                                        <ErrorModal errorMsg={errorMessage} handleCloseModal={handleCloseModalError} openModalError={openModalError} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <LoadingLockPage load={promiseInProgress} />
                </>
                :
                <Redirect to="/" />
            }
        </>
    )
}

export default MassMessageCompany;